const m = require('minthril');
const { component } = require('../../component');
const { HourlyUsageGraph } = require('../../components/hourly-usage-graph');
const { SiteNavigation } = require('../../components/site-navigation');
const { UsageTotals } = require('../../components/usage-totals');

const TrafficPage = component(() => ({
  view: ({ attrs }) => {
    const {
      site,
      stats,
      backHref = '/sites',
      overviewHref,
      trafficHref,
      routesHref,
      costHref,
      settingsHref,
      onUsagePeriodChange,
      usagePeriodHours
    } = attrs;

    return m('section.panel.site-detail.traffic-page', [
      m(SiteNavigation, {
        breadcrumbs: [
          { label: backHref.startsWith('/admin') ? 'Admin' : 'Sites', href: backHref },
          { label: site.name, href: overviewHref },
          { label: 'Traffic' }
        ],
        overviewHref,
        trafficHref,
        routesHref,
        costHref,
        settingsHref,
        current: 'traffic'
      }),
      m('h2', site.name),
      m('p.traffic-page__origin', site.origin),
      stats ? [
        m(HourlyUsageGraph, {
          hourlyUsage: stats.hourlyUsage,
          periodHours: usagePeriodHours || stats.usagePeriodHours,
          onPeriodChange: onUsagePeriodChange
        }),
        m(UsageTotals, { usage: stats.usage })
      ] : m('p.muted', 'Loading traffic…')
    ]);
  }
}));

module.exports = { TrafficPage };
